import React from 'react';
import {
  Divider, Message, Container, Loader,
} from 'semantic-ui-react';
import {
  bool, string, shape, func,
} from 'prop-types';

import Text from './Text';
import SearchResults from './SearchResults';
import Copyright from './Copyright';

const Body = ({
  hasError,
  errorText,
  loadingBody,
  body,
  displayingSearch,
  loadingSearchResults,
  searchResults,
  updateBook,
}) => (
  <>
    <Divider />
    {hasError && <Message>{String(errorText)}</Message>}
    <Container>
      {loadingBody && (
        <Loader active inline="centered" style={{ margin: '15em auto' }} />
      )}
      {!loadingBody && !displayingSearch && <Text body={body.data} />}
      {displayingSearch && (
        <SearchResults
          loadingSearchResults={loadingSearchResults}
          searchResults={searchResults}
          updateBook={updateBook}
        />
      )}
    </Container>
    <Divider />
    {body.data && <Copyright copyright={body.data.copyright} />}
  </>
);

Body.propTypes = {
  hasError: bool.isRequired,
  errorText: string.isRequired,
  loadingBody: bool.isRequired,
  body: shape().isRequired,
  displayingSearch: bool.isRequired,
  loadingSearchResults: bool.isRequired,
  searchResults: shape().isRequired,
  updateBook: func.isRequired,
};

export default Body;
